import { render, staticRenderFns } from "./BannersPage.vue?vue&type=template&id=1108c2f2&scoped=true&lang=html&"
import script from "./BannersPage.vue?vue&type=script&lang=js&"
export * from "./BannersPage.vue?vue&type=script&lang=js&"
import style0 from "./BannersPage.vue?vue&type=style&index=0&id=1108c2f2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1108c2f2",
  null
  
)

export default component.exports